import { useMutation } from "@tanstack/react-query";
import { AuthService } from "../AuthService";
import { SignInRequest } from "../models";
import { useAuthStoreSelectors } from "@/shared/stores";

export const useSignIn = () => {
  const setUserName = useAuthStoreSelectors.use.setUserName();
  const setUserId = useAuthStoreSelectors.use.setUserId();

  const { isPending, mutateAsync: signIn } = useMutation({
    mutationFn: async (params: SignInRequest) => {
      const response = await AuthService.signIn(params);
      return response?.data?.patient_data;
    },
    onSuccess: (data) => {
      setUserName(data.name);
      setUserId(data.id);
    },
  });

  return { isPending, signIn };
};
